import { useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_LEGAL_DOCUMENTS_QUERY } from 'src/graphql/entities/legal-document/legal-document.operations';
import {
  type GetLegalDocumentsQueryData,
  type LegalDocument,
} from 'src/graphql/entities/legal-document/legal-document.types';

const NO_DOCUMENTS: LegalDocument[] = [];

export const useLegalDocuments = (partnerId: number | null, { skip = false } = {}) => {
  const { data, loading, error, refetch } = useQuery<GetLegalDocumentsQueryData>(
    GET_LEGAL_DOCUMENTS_QUERY,
    {
      skip: skip || isNullish(partnerId),
      variables: { input: { partnerId: partnerId ?? 0 } },
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
      context: { ttl: 0 },
    },
  );

  return { documents: data?.getLegalDocuments ?? NO_DOCUMENTS, loading, error, refetch };
};
